import { Dialog, Pagination } from "@dashboard/types";
import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const cartVisibilitySection = "/live-carts";
export const cartVisibilityListPath = cartVisibilitySection;

export type CartVisibilityListUrlQueryParams = Dialog<string> & Pagination;

export const cartVisibilityListUrl = (params?: CartVisibilityListUrlQueryParams) => {
  if (params === undefined) {
    return cartVisibilityListPath;
  }

  return urlJoin(cartVisibilityListPath, "?" + stringifyQs(params));
};

export const cartVisibilityDetailPath = (id: string) => `${cartVisibilitySection}/${id}`;

export const cartVisibilityUrl = (id: string) => cartVisibilityDetailPath(encodeURIComponent(id));
